module.exports = __webpack_public_path__ + "static/media/Capa-WB43Capitulos.a56da695.PNG";